/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { getRequest } from "utils/request";

import './style.css'

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { Bar } from "react-chartjs-2";

import { i18n } from '../../../translate/i18n';
import { useModal } from 'hooks/modal';
import format from 'date-fns/format';

function AttendentDashboard() {
	const [companyByStatus, setCompanyByStatus] = useState([]);
	const [scheduledToday, setScheduledToday] = useState([]);
	const [attendentRatings, setAttendentRatings] = useState([]);
  const [basicData, setBasicData] = useState({});
  const [basicChart, setBasicChart] = useState({});
	const [companyByLate, setCompanyByLate] = useState([]);
	const [colors, setColors] = useState(['red', 'green', 'blue', 'yellow', 'pink', '#33FF55', '#FF9B00', '#00D4FF', '#8700FF', '#87FF00'])
  const user = JSON.parse(sessionStorage.getItem('@Omni:user'));
  const { toggleHelperId} = useModal();

	const getByStatus = async() => {
		try {
      const ReturnGet = await getRequest(`dashboards/agent/bystatus`);      
      if (ReturnGet.success) {
        setCompanyByStatus(ReturnGet.data);
      }
		} catch (error) {
			console.log(error)
		}
	}

	const getByLate = async() => {
		try {
      const ReturnGet = await getRequest(`dashboards/agent/late`);      
      if (ReturnGet.success) {
        setCompanyByLate(ReturnGet.data)
      }
		} catch (error) {
			console.log(error)
		}
	}

	const getScheduledToday = async() => {
		try {
      const ReturnGet = await getRequest(`dashboards/agent/scheduledkute`);      
      if (ReturnGet.success) {
        setScheduledToday(ReturnGet.data)
      }      
		} catch (error) {
			console.log(error)
		}
	}

	const getMyRatings = async() => {
		try {
      const ReturnGet = await getRequest(`dashboards/agent/myratings`);      
      if (ReturnGet.success) {
        setAttendentRatings(ReturnGet.data)
      }            
		} catch (error) {
			console.log(error)
		}
	}

  const getAttendentPerWeek = async(color) => {
    let date = [];

    let basicData = {
      labels: [],
      datasets: []
    } 

    const ReturnGet = await getRequest(`dashboards/agent/attendedweek`);      
    if (ReturnGet.success && ReturnGet.data.length > 0) {
      ReturnGet.data.forEach((item) => {
      date.push(format(new Date(item.date), 'dd/MM/yyyy'));

      const foundIndex = basicData.datasets.findIndex(c => c.label === item.nickName);
      var color = [Math.floor(Math.random() * colors.length)]

      if (foundIndex !== -1) {
        basicData.datasets[foundIndex].data = [...basicData.datasets[foundIndex].data, item.quantity];
      } else {
        basicData.datasets.push({
          label: item.nickName,
          data: [item.quantity],
          fill: false,
          borderWidth: 1.5,
          borderColor: colors[color]
        })
        colors.splice(color, 1);
        setColors([...colors])
      }
    });

    basicData.labels = [...new Set(date)];

    setBasicData(basicData);
    }

  }

	const getLatePerWeek = async() => {
		let dateChart = [];

    let basicChart = {
      labels: [],
      datasets: []
    }

    const ReturnGet = await getRequest(`dashboards/agent/lateweek`);      
    if (ReturnGet.success && ReturnGet.data.length > 0) {
      ReturnGet.data.forEach((item) => {
        dateChart.push(format(new Date(item.date), 'dd/MM/yyyy'));

        const foundIndex = basicChart.datasets.findIndex(c => c.label === item.nickName)
        if (foundIndex !== -1) {
          basicChart.datasets[foundIndex].data = [...basicChart.datasets[foundIndex].data, item.quantity];
        } else {
            basicChart.datasets.push({
            label: item.nickName,
            data: [item.quantity],
            fill: true,
            backgroundColor: '#42A5F5'
            })
        }
      });

      basicChart.labels = [...new Set(dateChart) ];

      setBasicChart(basicChart);
    }
	}

	useEffect(() => {
		getByStatus();
		getByLate();
		getScheduledToday();
		getMyRatings();
		getLatePerWeek();
		getAttendentPerWeek();
    toggleHelperId(23);
	}, []);

	const actionButtonsTemplate = (data) => {
    return (
      <div style={{display: "flex", flexDirection: "row"}}>
        <div
          className="action-icon"
          style={{ cursor: "pointer", marginRight: 10 }}
        >
          <i className="fas fa-exclamation-circle" style={{fontSize: 20}}></i>
        </div>
      </div>
    )
  }

  return (
		<div className="attendent-container">
			<div className="attendent-list">
      
      {user?.skuteService && 
        <div className="col md-1 sd-1 lg-3">
            <div className="card widget-flat" style={{padding: 20}}>
              <h4 className="h4-attendent">SKUTE - {i18n.t('shedulingToday')} </h4>
              <div className="dataTable">
                <DataTable className="p-datatable-striped" value={scheduledToday} emptyMessage='Nenhum dado registrado.'>
                  <Column style={{width: '40%'}} field='nickName' header="Empresa"></Column>
                  <Column field='name' header="Nome"></Column>
                  <Column body={actionButtonsTemplate} header="Ação"></Column>
                </DataTable>
              </div>
            </div>
        </div>
      }


        <div className="col md-1 sd-1 lg-3">
          <div className="card widget-flat" style={{padding: 20}}>
					  <h4 className="h4-attendent">{i18n.t('perStatus')}</h4>
					  <div className="dataTable">
              <DataTable className="p-datatable-striped" value={companyByStatus} emptyMessage='Nenhum dado registrado.'>
                <Column style={{width: '30%'}} field='nickName' header="Empresa"></Column>
                <Column	field='status' header="Status"></Column>
                <Column  field='quantity' header="Qtde"></Column>
              </DataTable>
					  </div>
          </div>
        </div>
        
				<div className="col md-1 sd-1 lg-3">
          <div className="card widget-flat" style={{padding: 20}}>
					  <h4 className="h4-attendent">{i18n.t('perLate')}</h4>
					  <div className="dataTable">
              <DataTable className="p-datatable-striped" value={companyByLate} emptyMessage='Nenhum dado registrado.'>
                <Column field='nickName' header="Empresa"></Column>
                <Column field='quantity' header="Quantidade"></Column>
              </DataTable>
            </div>
					</div>
				</div>
			</div>

      <div className="attendent-graphics">

      {user?.skuteService && 
        <div className="col md-1 sd-1 lg-3">
          <div className="card widget-flat" style={{padding: 20}}>
            <h4 className="h4-attendent">{i18n.t('avaliations')}</h4>
            <div className="dataTable">
              <DataTable className="p-datatable-striped" value={attendentRatings} emptyMessage='Nenhum dado registrado.'>
                <Column field='nickName' header="Empresa"></Column>
                <Column field='score' header="Nota"></Column>
              </DataTable>
            </div>
          </div>
        </div>
      }
        
        <div className="col md-1 sd-1 lg-3">
				  <div className="card widget-flat">
            <div className="card-body" style={{width: '100%'}}>
                <h4 className="h4-attendent">{i18n.t('schedulingperWeek')}</h4>
                <Bar type="line" data={basicData} />
            </div>
				  </div>
        </div>

        <div className="col md-1 sd-1 lg-3">
          <div className="card widget-flat">
            <div className="card-body" style={{width: '100%'}}>
              <h4 className="h4-attendent">{i18n.t('latePerWeek')}</h4>
              <Bar type="bar" data={basicChart}/>
            </div>
          </div>
        </div>
			</div>
		</div>
	);
}

export default AttendentDashboard;